import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "#1D1B20", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 18.6979V16.6979H21V18.6979H3ZM3 13.6979V11.6979H21V13.6979H3ZM3 8.69788V6.69788H21V8.69788H3Z" }));
export default SvgMenu;
